import React from 'react'
import MenuDropDown from './MenuDropDown'
import PictureContainer from './PictureContainer'
import FileUpload from './FileUpload'

import DropDown from './DropDown'
// import imageToBase64 from 'image-to-base64'
import './CategoryDetail.css'
import {
    Button,
    ButtonGroup,
    SplitButton,
    SplitButtonItem,
    ToolbarSpacer,
    DropDownButton,
    DropDownButtonItem,
    Toolbar,
    ToolbarItem,
    ToolbarSeparator,
} from '@progress/kendo-react-buttons'
import { Label } from '@progress/kendo-react-labels'
import { Input } from '@progress/kendo-react-inputs'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { MultiSelect } from '@progress/kendo-react-dropdowns'

import { WebInfoModal, ExternalContentModal } from './Modals'
import { getBaseURL } from '../../GlobalComponents/URLs'
const CAT_IMAGE_URL = `${getBaseURL()}InvtForms/InventoryImage.aspx?Category=`
const imageRegex = /<img.*?src=['"](.*?)["']/

const NavBar = ({ nodeId, tree, setCurrentCategory, leaf }) => {
    let node = tree[nodeId].node
    let menuItems = []
    tree[node.ParentId].children.forEach((ele) => {
        if (ele !== node.CategoryId) {
            let newMenuItem = {}
            newMenuItem.text = tree[ele].node.Name
            newMenuItem.onClick = () => setCurrentCategory(ele)
            menuItems.push(newMenuItem)
        }
    })
    return (
        <>
            {node.ParentId !== -1 && (
                <NavBar
                    nodeId={node.ParentId}
                    tree={tree}
                    setCurrentCategory={setCurrentCategory}
                />
            )}
            {leaf ? (
                <MenuDropDown
                    menuTitle={node.Name !== '' ? node.Name : '*No Name*'}
                    listItems={menuItems}
                />
            ) : (
                <>
                    {' '}
                    <MenuDropDown menuTitle={node.Name} listItems={menuItems} />{' '}
                    <div style={{ color: 'red', display: 'inline' }}>{'>'}</div>{' '}
                </>
            )}
        </>
    )
}

const treeKidFnc = (tree, nodeId, fnc) => {
    let res = fnc(tree[nodeId].node)
    tree[nodeId].children.forEach((ele) => {
        res += treeKidFnc(tree, ele, fnc)
    })
    return res
}
const App = (props) => {
    const [category, setCategory] = React.useState(props.currentCategory)
    const [itemCount, setItemCount] = React.useState(0)
    const [hasChanges, setHasChanges] = React.useState(false)
    const [currentModal, setCurrentModal] = React.useState(null)
    // const {setCurrentModal} = props
    const { canWrite } = props
    React.useEffect(() => {
        if (!props.currentCategory) {
            return
        }
        // first letter changes object bug from copying just the object
        setCategory(JSON.parse(JSON.stringify(props.currentCategory)))
        //get itemCount
        let newItemCount = treeKidFnc(props.treeInfo, props.currentCategory.CategoryId, (node) => {
            return node.PartCount || 0
        })
        setItemCount(newItemCount)
    }, [props.currentCategory])

    React.useEffect(() => {
        props.categoryRef.current = category
    }, [category])

    React.useEffect(() => {
        let handle = setInterval(() => setHasChanges(!props.canChangeCategory()), 200)
        return () => clearInterval(handle)
    }, [props.canChangeCategory, props.currentCategory])
    let primaryTechOptions = [
        { key: 4, value: 4, text: 'Instrumentation' },
        { key: 2, value: 2, text: 'Electrical' },
        { key: 1, value: 1, text: 'Factory Automation' },
        { key: 7, value: 7, text: 'Process Automation' },
        { key: 5, value: 5, text: 'Valves/Flow Control' },
    ]

    const onDrop = (e) => {
        e.stopPropagation()
        e.preventDefault()
        let reader = new FileReader()
        reader.addEventListener(
            'load',
            function () {
                let uri = reader.result
                setCategory((category) => {
                    category.Image = uri
                    return { ...category }
                })
            },
            false
        )
        let haveImage = false
        if (e.dataTransfer.files.length > 0 && e.dataTransfer.files[0].type.includes('image')) {
            haveImage = true
            reader.readAsDataURL(e.dataTransfer.files[0])
        } else if (e.dataTransfer.items.length > 0) {
            let data = e.dataTransfer.items

            for (var i = 0; i < data.length; i++) {
                if (data[i].kind == 'string' && data[i].type.match('^text/html')) {
                    // Drag data item is HTML
                    data[i].getAsString(function (s) {
                        let src = imageRegex.exec(s)
                        if (src) {
                            let downloadedImg = new Image()
                            downloadedImg.crossOrigin = 'Anonymous'
                            downloadedImg.addEventListener(
                                'load',
                                () => {
                                    // console(downloadedImg)
                                },
                                false
                            )
                            downloadedImg.src = src[1]
                            return
                        }
                    })
                } else if (data[i].kind == 'string' && data[i].type.match('^text/uri-list')) {
                    // Drag data item is URI
                    // data[i].getAsString(function (s) {
                    //     console('... Drop: URI = ' + s)
                    // })
                }
            }
        }
        if (!haveImage) {
            alert('Dropped file is not an image')
        }
    }

    return !category ? null : (
        <div className="categoryDetailContainer">
            {/* <div className="categoryTitleContainer">
            <div style={{flex: 0.8}}>
                <NavBar nodeId={category.CategoryId} tree={props.treeInfo} 
                    setCurrentCategory={props.setCurrentCategory} leaf/>
            </div>
            {canWrite && 
            <div style={{flex: 0.2, display:'flex'}}>
                <Button  primary={hasChanges} style={{flex: 1}} 
                    onClick={()=>props.handleCatSave(category.CategoryId)}>Save </Button>
            </div>}
        </div> */}
            <div className="categoryBodyContainer">
                <div className="categoryInfo">
                    <div>
                        <NavBar
                            nodeId={category.CategoryId}
                            tree={props.treeInfo}
                            setCurrentCategory={props.setCurrentCategory}
                            leaf
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                            className="categoryInfoItem categoryInfoItem1"
                            style={{
                                flex: '0 0 200px',
                                marginLeft: 30,
                            }}
                        >
                            <Label
                                style={{
                                    verticalAlign: 'middle',
                                    lineHeight: 2,
                                    marginRight: 10,
                                    fontWeight: 500,
                                }}
                                editorId={'cdKey'}
                            >
                                Key:{' '}
                            </Label>
                            <p
                                id={'cdKey'}
                                style={{ verticalAlign: 'middle', lineHeight: 2, marginRight: 10 }}
                            >
                                {category.CategoryId}
                            </p>
                        </div>

                        <div className="categoryInfoItem categoryInfoItem6" style={{ flex: 1 }}>
                            <Label
                                style={{
                                    verticalAlign: 'middle',
                                    lineHeight: 2,
                                    marginRight: 10,
                                    fontWeight: 500,
                                }}
                                editorId="cdName"
                            >
                                Name:{' '}
                            </Label>
                            <Input
                                id={'cdName'}
                                className="form-control form-control-sm"
                                onChange={(e) => {
                                    setCategory((category) => {
                                        category.Name = e.target.value
                                        return { ...category }
                                    })
                                }}
                                style={{ flex: 3 }}
                                value={category.Name}
                                disabled={!canWrite}
                            />
                        </div>

                        <div
                            className="categoryInfoItem categoryInfoItem10"
                            style={{
                                flex: '0 0 150px',
                                marginLeft: 30,
                            }}
                        >
                            <input
                                className="form-check-input"
                                name={'MV|YES'}
                                id={'MV|YES'}
                                // ref={inputYes}
                                checked={category.MenuVisible}
                                onChange={(e) => {
                                    setCategory((category) => {
                                        category.MenuVisible = e.target.checked
                                        return { ...category }
                                    })
                                }}
                                style={{ height: 20, width: 15 }}
                                disabled={!canWrite}
                                type="checkbox"
                            // disabled={props.disabled}
                            />
                            <Label
                                style={{
                                    verticalAlign: 'middle',
                                    lineHeight: 2,
                                    marginRight: 10,
                                    fontWeight: 500,
                                }}
                                editorId="MV|YES"
                            >
                                Menu Visible{' '}
                            </Label>
                        </div>
                    </div>

                    <div
                        style={{
                            // width: 400,
                            display: 'flex',
                            justifyContent: 'space-around',
                            height: 40,
                        }}
                    >
                        <Button
                            style={{ flex: 1, maxWidth: 200, fontSize: 18 }}
                            primary={true}
                            className="btn btn-sm btn-info"
                            onClick={() =>
                                setCurrentModal(
                                    <WebInfoModal
                                        categoryRef={props.categoryRef}
                                        category={category}
                                        close={() => setCurrentModal(null)}
                                    />
                                )
                            }
                        >
                            Web Detail
                        </Button>

                        <Button
                            style={{ flex: 1, maxWidth: 200, fontSize: 18 }}
                            primary={true}
                            className="btn btn-sm btn-info"
                            onClick={() =>
                                setCurrentModal(
                                    <ExternalContentModal
                                        categoryRef={props.categoryRef}
                                        category={category}
                                        close={() => setCurrentModal(null)}
                                    />
                                )
                            }
                        >
                            External Content
                        </Button>
                    </div>
                </div>
                <div className="categoryPicture">
                    {canWrite && (
                        <div style={{ display: 'flex', height: 30 }}>
                            <Button
                                primary={hasChanges}
                                style={{ flex: 1 }}
                                onClick={() => props.handleCatSave(category.CategoryId)}
                            >
                                Save{' '}
                            </Button>
                        </div>
                    )}
                    {/* {canWrite && <Button  primary={hasChanges} 
                        onClick={()=>props.handleCatSave(category.CategoryId)}>Save </Button>} */}
                    {/* to avoid separating from the left side causing increased flex height */}
                    {/* <PictureContainer style={{height: 'calc(20vh - 32px)'}} 
                    handleFile={(file)=>setCategory(category => {
                        
                        category.Image = file
                        return {...category}
                    })}
                    onDrop={canWrite && onDrop} 
                        src={category && category.Picture ? 
                                category.Picture :
                                `${CAT_IMAGE_URL}${category.CategoryId}`} /> */}
                    {/* {canWrite && <FileUpload 
                    handleFile={(file)=>setCategory(category => {
                      
                        category.Image = file
                        return {...category}
                    })}
                />} */}
                </div>
            </div>
            {currentModal}
        </div>
    )
}

App.defaultProps = {
    currentCategory: false,
    treeInfo: false,
    onKeyChange: (text) => null,
    onItemsChange: (text) => null,
    onAttributesChange: (text) => null,
    onDisplayOrderChange: (text) => null,
    onWebMarketStatementChange: (text) => null,
    onPrimaryTechnologyChange: (text) => null,
    onNameChange: (text) => null,
    onWebsiteHLChange: (text) => null,
    onCategoryFieldChange: (text, key) => null,
}

export default App
